var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('b-btn',{attrs:{"variant":_vm.position_update_recenter?'success':'dark'},on:{"click":_vm.recenter}},[_c('span',{staticClass:"glyphicon glyphicon-screenshot"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }